export class DocumentTemplate {
    id?: string;
    nomeArquivo?: string;
    tipoDeDocumento?: number;
    arquivo?: File;
    urlDownload?: string;
}